import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface MetadataI {
  page: number,
  page_size: number,
  total_items: number,
  total_pages: number
}

export interface GetApprovalVendorsPayloadI {
  search?: string,
  status_approval: string,
  employee_email: string,
  sort_by: string,
  sort_type: string,
  page_number: number,
  page_size: number,
}

export interface ApprovalVendorI {
  id: number,
  vendor_code: string,
  vendor_name: string,
  vendor_address: string,
  type_vendor: string,
  bank_key: string,
  bank_account: string,
  bank_name: string,
  bank_account_number: string,
  bank_account_name: string,
  status_vendor: string,
  status_approval: string,
  create_at: string,
  flag_column: string,
  flag_column_desc: string,
  pool_department: {
    vendor_code: string,
    pool_id: string,
    department: string
  }[],
  vendor_files: {
    id: number,
    trx_id: string,
    item_id: number,
    file_name: string,
    path_file: string,
    source_file: string,
    source_key: string,
    file_size: string,
    create_at: string,
    create_by: string
  }[],
  approvals: {
    id: number,
    trx_id: string,
    approval_code: string,
    approval_number: number,
    department: string,
    job_id: number,
    job_title: string,
    job_flow: string,
    employee_id: string,
    employee_name: string,
    employee_email: string,
    status_approval: string,
    reason_status: string,
    status_bon: string,
    approval_start: string,
    approval_end: string,
    create_at: string,
    create_by: string,
    update_at: string,
    update_by: string
  }[]
}

export interface PostResponseI {
  responseCode: "Succeed" | "Failed",
  responseMessage: string
}

export interface GetApprovalVendorsResponseI {
  list_approval_mst_vendor: ApprovalVendorI[]
  metadata: MetadataI
}

const url = "/v1/smplmstvendorapproval";

export const getApprovalVendors = async (
  payload: GetApprovalVendorsPayloadI,
): Promise<GetApprovalVendorsResponseI> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

interface PostApprovalVendorPayloadI {
  vendor_code: string,
  employee_email: string,
  update_by: string,
  reason: string
}

export const postApprovalVendor = async (
  type: "approve" | "reject",
  payload: PostApprovalVendorPayloadI,
): Promise<PostResponseI> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${type}`,
    method: "POST",
    data: payload,
  });

  return data;
};
